import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/sign-up'
    },
    {
      path: '/course/:id/:lectureIndex?',
      name: 'LectureList',
      props: true,
      component: () =>
        import('@/views/LectureList')
    },
    {
      path: '/add_course',
      name: 'add_course',
      component: () =>
        import('@/views/AddCourse')
    },
    {
      path: '/users/:uid',
      name: 'User',
      props: true,
      component: () =>
        import('@/views/User')
    },
    {
      path: '/set_profile/:uid',
      name: 'SetProfile',
      props: true,
      component: () =>
        import('@/views/SetProfile')
    },
    {
      path: '/settings',
      name: 'settings',
      component: () =>
        import('@/views/Settings')
    },
    {
      path: '/trainer/report_list',
      name: 'report_list',
      component: () =>
        import('@/views/TrainerReportList')
    },
    {
      path: '/trainer/report_list/:traineeId/:courseId/:lectureIndex',
      name: 'report_list',
      component: () =>
        import('@/views/TrainerReportList')
    },
    {
      path: '/trainer/home',
      name: 'trainer_home',
      component: () =>
        import('@/views/TrainerHome')
    },
    {
      path: '/application',
      name: 'application',
      component: () =>
        import('@/views/Application')
    },
    {
      path: '/application-complete/:courseId?',
      name: 'application-complete',
      props: true,
      component: () =>
        import('@/views/ApplicationComplete')
    },
    {
      path: '/card-registration-complete/:courseId?',
      name: 'card-registration-complete',
      props: true,
      component: () =>
        import('@/views/ApplicationComplete')
    },
    {
      path: '/application-survey/:courseId?',
      name: 'application-survey',
      props: true,
      component: () =>
        import('@/views/ApplicationSurvey')
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: () =>
        import('@/views/SignInForApplication')
    },
    {
      path: '/sign-in/change-card',
      name: 'sign-in-change-card',
      component: () =>
        import('@/views/SignInForApplication')
    },
    {
      path: '/sign-up/:partnerId?',
      name: 'sign-up',
      component: () =>
        import('@/views/SignInForApplication')
    },
    {
      path: '/payment/:couponCode?',
      name: 'payment',
      props: true,
      component: () => import('@/views/PaymentCardRegistration')
    }
  ]
})
